var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"inspire"}},[(_vm.user)?_c('AppBar'):_vm._e(),_c('v-main',{staticClass:"pt-20 mt-20"},[_c('router-view',{staticClass:"animate__animated animate__fadeInLeft"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }